<footer>
  <div class="main-footer">
    <div class="main-footer-items">
      <div class="footer-logo">
      </div>
      <div class="footer-version">{{footer}}</div>
    </div>
  </div>
</footer>

